import FormatPrice from '@/elements/Product/Price/FormatPrice';
import { View } from '@/components/Theme';
import { Line } from '@/utils/Line';
import isEqual from 'lodash/isEqual';
import { memo, useCallback, useState } from 'react';
import { useThemeColor } from '@/hooks/useThemeColor';

const RegularPrice = ({price, currency = 'EUR', ...rest}) => {

    const {
        lineThrough = false,
        lineThroughColor = null,
        ...textRest
    } = rest ?? {};

    const [height, setHeight] = useState(1);

    const lineColor = useThemeColor(lineThroughColor != null ? lineThroughColor : {light: 'black', dark: 'white'});
    
    const updateHeight = useCallback((e) => {
        if (height === 1)
            setHeight(e?.nativeEvent?.layout?.height);
    }, [height]);
    try {
        
        return (
            <View flexDirection={'row'} onLayout={updateHeight} position={'relative'} alignItems={'center'}>
                
                <FormatPrice 
                    price={price} 
                    currency={currency} 
                    variant={ lineThrough ? ['h4', 'light', 'right'] : ['h1', 'right']} 
                    light={'black'}
                    dark={'white'}
                    {...textRest}
                />

                {lineThrough && 
                    <Line 
                        bg={lineColor} 
                        style={{position:'absolute'}} 
                    />
                }
            </View>
        );

    } catch (e) {
        return null;
    }

};

export default memo(RegularPrice, isEqual);